const activeClass = 'activeClass';

const scroll = {
	line: document.getElementById('jsLineWrap') as HTMLElement,
	btn: document.getElementById('jsProdBtn') as HTMLElement,

	init(): void {
		if (!this.btn) return;

		this.setScroll();
		this.checkScroll();
	},

	setScroll(): void {
		window.addEventListener('scroll', () => {
			this.checkScroll();
		});
	},

	checkScroll(): void {
		const isScrolled = window.scrollY >= 1200;

		this.btn.classList.toggle(activeClass, isScrolled);
	}
};

export default scroll;